<div class="case" #imgShow (mousewheel)="resizeImg($event);$event.stopPropagation()" >
  <div class="close" (click)="closeShow()">X</div>
  <img [src]="showImg" #Img/>
</div>
